/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */
const { connectHierarchicalMenu, connectNumericMenu, connectRatingMenu } = instantsearch.connectors;
const { relevantSort, queryRuleContext } = instantsearch.widgets;
const { connectRelevantSort } = instantsearch.connectors;
const { connectSortBy } = instantsearch.connectors;
const { connectInfiniteHits } = instantsearch.connectors;
let infiniteHits2 = instantsearch.widgets.infiniteHits;
const sessionStorageCache = instantsearch.createInfiniteHitsSessionStorageCache();

(function(algolia) {
  
  'use strict';

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  var botPattern = "(googlebot\/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
  var re = new RegExp(botPattern, 'i');
  var userAgent = navigator.userAgent;
  let isBot = false;
  if (re.test(userAgent)) {
    isBot = true;
  }

  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  var hits = infiniteHits2
  if(isBot) {
    hits = algolia.externals.widgets.hits;
  }
  var pagination = algolia.externals.widgets.pagination;
  var configure = algolia.externals.widgets.configure;
  var connectCurrentRefinements =
    algolia.externals.connectors.connectCurrentRefinements;

  
  //console.log("instantsearch", instantsearch)

  var collectionPageEnabled =
    algolia.is_collection_results_page &&
    algolia.config.instant_search_enabled_on_collection;

  if (!algolia.full_results && !algolia.is_collection_results_page) {
    /**
     * If we aren't on the search page and neither on a collection page,
     * then there's no need to proceed
     */
    return;
  } else if (algolia.full_results) {
    //console.log("full results")
    /**
     * If we are on the search page and instant search isn't enabled,
     * then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled) {
      return;
    }
  } else if (algolia.is_collection_results_page) {
    /**
     * If we are on a collection page and instant search on collection isn't
     * enabled, then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled_on_collection) {
      return;
    }
  }

  /**
   * Array which will contain all filters to be applied while initiating the
   * search API call.
   */
  var searchFilters = [];

  var collectionFacetFilter = null;
  var collectionRulesContextValue = null;
  var collectionHandle = null;

  if (collectionPageEnabled) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    collectionHandle =
      Boolean(matches) && matches.length === 2 ? matches[1] : null;

    if (algolia.config.collection_id_indexing) {
      collectionFacetFilter = collectionHandle
        ? 'collections:"' + collectionHandle + '"'
        : null;
    } else {
      collectionFacetFilter = 'collections:"' + collectionHandle + '"';
    }

    // Add the collection filter to the list of search filters
    searchFilters.push(collectionFacetFilter);

    collectionRulesContextValue = algolia.config.collection_id_query_rules
      ? algolia.current_collection_id
      : collectionHandle;

      
  }

  // Filters for stock policy
   var filter_tag_oos = 'NOT tags:algolia30days';
   if (filter_tag_oos) {
     searchFilters.push(filter_tag_oos);
  }
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
    } else if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      // stockPolicyFilter = 'inventory_quantity > 0';
      
    } else if (algolia.config.stock_policy === 'continue') {
      /**
       * For 'continue' we will filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter = 'inventory_available:true';
    }

    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }

  var results_selector = collectionPageEnabled
    ? algolia.config.collection_css_selector
    : algolia.config.results_selector;

  var activeSortOrders =
    collectionPageEnabled && algolia.collectionSortOrders
      ? algolia.collectionSortOrders
      : algolia.sortOrders;

  results_selector += ', .algolia-shopify-instantsearch';

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function(k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  /**
   * List of URL params which are "allowed" by InstantSearch.
   * These parameters won't be overwritten when the search state is written
   * to the URL.
   */
  var ALLOWED_FOREIGN_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ];
  var foreignRouteState;

  function singleIndex(indexName) {
    return {
      /**
       * `stateToRoute` method transforms the `uiState` object from InstantSearch
       * into an object that will then be serialized to construct the URL.
       */
      stateToRoute: function(uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return Object.assign({}, foreignRouteState, route);
      },

      /**
       * `routeToState` method transforms the route object into a `uiState` object
       * so that InstantSearch is initialized with the correct state from the
       * URL.
       */
      routeToState: function(routeState) {
        /**
         * Backup parameters from `routeState` into a different object
         * `foreignRouteState` so that we can re-inject them into the object
         * returned within `stateToRoute`.
         * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
         * array.
         */
        if (!foreignRouteState) {
          foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function(acc, key) {
            acc[key] = routeState[key];
            return acc;
          }, {});
        }

        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    
    facets: {
     
      hidden:
        collectionPageEnabled && algolia.collectionHiddenFacets
          ? algolia.collectionHiddenFacets
          : algolia.hiddenFacets,
      shown:
        collectionPageEnabled && algolia.collectionShownFacets
          ? algolia.collectionShownFacets
          : algolia.shownFacets,
      list:
        collectionPageEnabled && algolia.collectionFacets
          ? algolia.collectionFacets
          : algolia.facets,
      widgets:
        collectionPageEnabled && algolia.collectionFacetsWidgets
          ? algolia.collectionFacetsWidgets
          : algolia.facetsWidgets,
    },
    hitsPerPage:
      collectionPageEnabled &&
      algolia.config.collections_full_results_hits_per_page
        ? algolia.config.collections_full_results_hits_per_page
        : algolia.config.products_full_results_hits_per_page,
    search: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      insights: algolia.config.analytics_enabled,
      indexName: algolia.config.index_prefix + 'products',
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + 'products'),
      },
      searchFunction: function(searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
        }

        // Assign any required filters
        if (searchFilters.length) {
          searchFunctionHelper.setQueryParameter(
            'filters',
            searchFilters.join(' AND ')
          );
        }

        // Assign any required `ruleContexts` which are required for query rules
        // targeting collection pages
        if (collectionPageEnabled) {
          // Collection page merchandising:
          // If we are on a collection page, `collectionRulesContextValue` is defined
          let ruleContexts = [];
          
          if (collectionRulesContextValue) {
            ruleContexts.push(collectionRulesContextValue.toString());
          }

          // Check if size filter is active
          const sizeRefinements = searchFunctionHelper.state.disjunctiveFacetsRefinements['options.size'] || [];
          if (sizeRefinements.length > 0) {
            ruleContexts.push('SizeFilterActive');
          }

          searchFunctionHelper.setQueryParameter('ruleContexts', ruleContexts);
        }

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
    selector: results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: activeSortOrders,
    sortFacetValuesBy: 'alpha'
  };

  //console.log("var instant: ", instant)
  instant.search.client.addAlgoliaAgent('Shopify Integration');
 
  algolia.instantsearch = instant;


  function readjust() {
    var width = instant.$results.offsetWidth;

    var suffix = 'lg';
    if (width < 400) suffix = 'xs';
    else if (width < 800) suffix = 'sm';
    else if (width < 1100) suffix = 'md';

    instant.$results.classList.remove('ais-results-size-xs');
    instant.$results.classList.remove('ais-results-size-sm');
    instant.$results.classList.remove('ais-results-size-md');
    instant.$results.classList.remove('ais-results-size-lg');
    instant.$results.classList.add('ais-results-size-' + suffix);
  }


  //Link CSS and set up CSS variables
  const cssFile = document.getElementById('template_algolia_instant_search.css');
  document.documentElement.style.setProperty(`--main-color`, `${algolia.config.colors.main}`);
  document.documentElement.style.setProperty(`--secondary-color`, `${algolia.config.colors.secondary}`);
  document.documentElement.style.setProperty(`--highlight-bg-color`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
  algolia.appendStyle(cssFile.text);

  if (collectionPageEnabled) {
    if (
      document.querySelectorAll(algolia.config.collection_css_selector)
        .length === 0
    ) {
      throw new Error(
        'Instant search CSS selector for collection page is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/advanced-customization/collection-search-page/#css-selector'
      );
    }
  } else if (
    document.querySelectorAll(algolia.config.results_selector).length === 0
  ) {
    throw new Error(
      'Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
    );
  }

  // Instantiating the main page
  instant.$results = document.querySelector(instant.selector);
  instant.$results.innerHTML = '';

  algolia.render(algolia.instantSearchMainTemplate, instant.$results, {
    facets: instant.facets.list,
    multipleSortOrders: activeSortOrders.length > 1,
    query: instant.query,
  });
 
  readjust();

  window.addEventListener('resize', function() {
    readjust();
  });


  // hierarquical menu

  // Create the render function
  var createDataAttributesCategories = function(refinement) {
    return Object.keys(refinement)
      .map(function(key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
      })
      .join(' ');
  };

  var renderListItemCategories = function(item) {
    var facet = instant.facets.list.find(function(f) {
      return f.name === item.label;
    });
    return item.refinements
      .map(function(refinement) {

        return (
          '<li class="ais-current-refined-values--item">' +
          '  <a ' +
          createDataAttributesCategories(refinement) +
          '    class="ais-current-refined-values--link">' +
          '    <div class="categories_label">' +
          '      <div class="ais-current-refined-values--label">' +
          '      </div> ' +
          refinement.label +
          '    </div>' +
          '  </a>' +
          '</li>'
        );
      })
      .join('');
  };

  var renderCurrentRefinementsCategories = function(renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;
    var filteredData = items.filter(item => item.attribute === "named_tags.lvl0");
    widgetParams.container.innerHTML =
      '<div class="ais-root ais-current-refined-values ais-facet categories_selected">' +
      '  <ul class="ais-current-refined-values--list">' +
      filteredData.map(renderListItemCategories).join('') +
      '  </ul>' +
      '</div>';

    Array.prototype.slice
      .call(
        widgetParams.container.querySelectorAll(
          '.ais-current-refined-values--link'
        )
      )
      .forEach(function(element) {
        element.addEventListener('click', function(event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function(
            acc,
            key
          ) {
            var itemData = {};
            itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
            return algolia.assign({}, acc, itemData);
          },
          {});

          refine(item);
        });
      });
  };

  // Create the custom widget
  var customCurrentRefinementsCategories = connectCurrentRefinements(
    renderCurrentRefinementsCategories
  );

  var renderListItemRating = function(item) {
    var facet = instant.facets.list.find(function(f) {
      return f.name === item.label;
    });
    return item.refinements
      .map(function(refinement) {

        return (
          '<li class="ais-current-refined-values--item">' +
          '  <a ' +
          createDataAttributesCategories(refinement) +
          '    class="ais-current-refined-values--link">' +
          '    <div class="rating_label">' +
          '      <div class="ais-current-refined-values--label">' +
          '      </div> ' +
          refinement.label +
          '    </div>' +
          '  </a>' +
          '</li>'
        );
      })
      .join('');
  };

  var renderCurrentRefinementsRating = function(renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;
    var filteredData = items.filter(item => item.attribute === "meta.product.okendo_review");
    widgetParams.container.innerHTML =
      '<div class="ais-root ais-current-refined-values ais-facet rating_selected">' +
      '  <ul class="ais-current-refined-values--list">' +
      filteredData.map(renderListItemRating).join('') +
      '  </ul>' +
      '</div>';

    Array.prototype.slice
      .call(
        widgetParams.container.querySelectorAll(
          '.ais-current-refined-values--link'
        )
      )
      .forEach(function(element) {
        element.addEventListener('click', function(event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function(
            acc,
            key
          ) {
            var itemData = {};
            itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
            return algolia.assign({}, acc, itemData);
          },
          {});

          refine(item);
        });
      });
  };

  // Create the custom widget
  var customCurrentRefinementsRating = connectCurrentRefinements(
    renderCurrentRefinementsRating
  );

  const renderList = ({ items, createURL }) => `
  <div class="ais-RefinementList ais-facet custom_hierarquical">

    <ul class="ais-RefinementList-list">
      
      ${items
        .map(
          item => `
            <li class="ais-RefinementList-item ais-facet--item">
              <a
                href=""
                class="categories_items ${item.data ? 'data_children' : ''} ${item.isRefined ? 'renifed_hierarquical' : ''}"
                data-value="${item.value}"
                style="font-weight: ${item.isRefined ? '' : ''}"
              >
                ${item.label} 
                <span class="ais-RefinementList-count ais-facet--count-distinct">  ${item.count} </span>
              </a>
             
              ${item.data ? renderList({ items: item.data, createURL }) : ''}
            </li>
          `
        )
        .join('')}
    </ul>
  </div>
   
  `;

  const renderHierarchicalMenu = (renderOptions, isFirstRender) => {
    const {
      items,
      //isShowingMore,
      refine,
      toggleShowMore,
      createURL,
      widgetParams,
    } = renderOptions;

    if (isFirstRender) {
      const list = document.createElement('div');
      const button = document.createElement('button');

      const selectedPrice = document.createElement('li');
      selectedPrice.setAttribute('class', 'ais-RefinementList-item ais-facet--item ais-RefinementList-item--selected price-selected-hidden');
      selectedPrice.innerHTML = `
      <div>
        <label class="ais-RefinementList-label ais-facet--label options_size"> 14 </label>
      </div>
      `

      button.addEventListener('click', () => {
        toggleShowMore();
      });
      widgetParams.container.appendChild(list);
      //widgetParams.container.appendChild(selectedPrice);
      
      // widgetParams.container.appendChild(button);
    }

    const children = renderList({ items, createURL });
    

    widgetParams.container.querySelector('div').innerHTML = children;
    // widgetParams.container.querySelector('button').textContent = isShowingMore
    //   ? 'Show less'
    //   : 'Show more';

    [...widgetParams.container.querySelectorAll('a')].forEach(element => {
      element.addEventListener('click', event => {
        event.preventDefault();
        refine(event.target.dataset.value);
      });
    });
  };

 
  // Create the custom widget
  const customHierarchicalMenu = connectHierarchicalMenu(
    renderHierarchicalMenu
  );


  instant.search.addWidgets([
    customHierarchicalMenu({
      container: document.querySelector('#hierarchical-menu'),
      attributes: [
        'named_tags.lvl0',
        'named_tags.lvl1',
        'named_tags.lvl2',
        'named_tags.lvl3'

      ],
      limit: 100,
      showMoreLimit: 50,
      showParentLevel: true,
      sortBy: ['name:asc']
    })
  ]);

//   // Create the render function
// const renderNumericMenu = (renderOptions, isFirstRender) => {
//   // `canRefine` is only available from v4.45.0
//   // Use `hasNoResults` in earlier minor versions.
//   const { items, canRefine, refine, widgetParams, } = renderOptions;

//   console.log(renderOptions);

//   widgetParams.container.innerHTML = `
//   <div class="ais-Panel">
//       <div class="ais-Panel-body">
//           <div>
//               <div class="ais-RefinementList ais-facet">
//                   <ul class="ais-RefinementList-list">
//                       ${items
//                         .map((item, index) => `
//                             <li data-value="${item.value}" class="ais-RefinementList-item ais-facet--item">
//                               <input
//                                 type="radio"
//                                 name="${widgetParams.attribute}"
//                                 value="${item.value}"
//                                 ${item.isRefined ? 'checked' : ''}
//                                 ${!canRefine ? 'disabled' : ''}
//                               />
//                               <div>
//                                 <label class="ais-RefinementList-label ais-facet--label meta_okendo_StarRatingSnippet">
//                                   ${
//                                     index != 0 ? `<span class="stars start_${index}">
//                                     <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
//                                     <path d="M5.50287 14.1882C5.41811 14.1882 5.33278 14.1621 5.2608 14.1093C5.11683 14.0048 5.05588 13.819 5.11161 13.6495L6.30338 9.97669L3.16984 7.69939C3.02529 7.59432 2.96492 7.40856 3.02065 7.23906C3.07522 7.06955 3.23311 6.95519 3.41133 6.95519H7.28384L8.47561 3.28411C8.53075 3.1146 8.68865 3.00024 8.86686 3.00024C9.04566 3.00024 9.20297 3.1146 9.25812 3.28411L10.4493 6.95519H14.3218C14.5 6.95519 14.6579 7.06955 14.7131 7.23906C14.7682 7.40856 14.7079 7.59432 14.5639 7.69939L11.4304 9.97669L12.6221 13.6495C12.6767 13.819 12.6169 14.0048 12.4723 14.1093C12.3284 14.2149 12.1339 14.2138 11.9888 14.1093L8.86686 11.8401L5.74435 14.1093C5.67237 14.1615 5.58762 14.1882 5.50287 14.1882Z" fill="black"/>
//                                     </svg><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
//                                     <path d="M5.50287 14.1882C5.41811 14.1882 5.33278 14.1621 5.2608 14.1093C5.11683 14.0048 5.05588 13.819 5.11161 13.6495L6.30338 9.97669L3.16984 7.69939C3.02529 7.59432 2.96492 7.40856 3.02065 7.23906C3.07522 7.06955 3.23311 6.95519 3.41133 6.95519H7.28384L8.47561 3.28411C8.53075 3.1146 8.68865 3.00024 8.86686 3.00024C9.04566 3.00024 9.20297 3.1146 9.25812 3.28411L10.4493 6.95519H14.3218C14.5 6.95519 14.6579 7.06955 14.7131 7.23906C14.7682 7.40856 14.7079 7.59432 14.5639 7.69939L11.4304 9.97669L12.6221 13.6495C12.6767 13.819 12.6169 14.0048 12.4723 14.1093C12.3284 14.2149 12.1339 14.2138 11.9888 14.1093L8.86686 11.8401L5.74435 14.1093C5.67237 14.1615 5.58762 14.1882 5.50287 14.1882Z" fill="black"/>
//                                     </svg><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
//                                     <path d="M5.50287 14.1882C5.41811 14.1882 5.33278 14.1621 5.2608 14.1093C5.11683 14.0048 5.05588 13.819 5.11161 13.6495L6.30338 9.97669L3.16984 7.69939C3.02529 7.59432 2.96492 7.40856 3.02065 7.23906C3.07522 7.06955 3.23311 6.95519 3.41133 6.95519H7.28384L8.47561 3.28411C8.53075 3.1146 8.68865 3.00024 8.86686 3.00024C9.04566 3.00024 9.20297 3.1146 9.25812 3.28411L10.4493 6.95519H14.3218C14.5 6.95519 14.6579 7.06955 14.7131 7.23906C14.7682 7.40856 14.7079 7.59432 14.5639 7.69939L11.4304 9.97669L12.6221 13.6495C12.6767 13.819 12.6169 14.0048 12.4723 14.1093C12.3284 14.2149 12.1339 14.2138 11.9888 14.1093L8.86686 11.8401L5.74435 14.1093C5.67237 14.1615 5.58762 14.1882 5.50287 14.1882Z" fill="black"/>
//                                     </svg><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
//                                     <path d="M5.50287 14.1882C5.41811 14.1882 5.33278 14.1621 5.2608 14.1093C5.11683 14.0048 5.05588 13.819 5.11161 13.6495L6.30338 9.97669L3.16984 7.69939C3.02529 7.59432 2.96492 7.40856 3.02065 7.23906C3.07522 7.06955 3.23311 6.95519 3.41133 6.95519H7.28384L8.47561 3.28411C8.53075 3.1146 8.68865 3.00024 8.86686 3.00024C9.04566 3.00024 9.20297 3.1146 9.25812 3.28411L10.4493 6.95519H14.3218C14.5 6.95519 14.6579 7.06955 14.7131 7.23906C14.7682 7.40856 14.7079 7.59432 14.5639 7.69939L11.4304 9.97669L12.6221 13.6495C12.6767 13.819 12.6169 14.0048 12.4723 14.1093C12.3284 14.2149 12.1339 14.2138 11.9888 14.1093L8.86686 11.8401L5.74435 14.1093C5.67237 14.1615 5.58762 14.1882 5.50287 14.1882Z" fill="black"/>
//                                     </svg><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
//                                     <path d="M5.50287 14.1882C5.41811 14.1882 5.33278 14.1621 5.2608 14.1093C5.11683 14.0048 5.05588 13.819 5.11161 13.6495L6.30338 9.97669L3.16984 7.69939C3.02529 7.59432 2.96492 7.40856 3.02065 7.23906C3.07522 7.06955 3.23311 6.95519 3.41133 6.95519H7.28384L8.47561 3.28411C8.53075 3.1146 8.68865 3.00024 8.86686 3.00024C9.04566 3.00024 9.20297 3.1146 9.25812 3.28411L10.4493 6.95519H14.3218C14.5 6.95519 14.6579 7.06955 14.7131 7.23906C14.7682 7.40856 14.7079 7.59432 14.5639 7.69939L11.4304 9.97669L12.6221 13.6495C12.6767 13.819 12.6169 14.0048 12.4723 14.1093C12.3284 14.2149 12.1339 14.2138 11.9888 14.1093L8.86686 11.8401L5.74435 14.1093C5.67237 14.1615 5.58762 14.1882 5.50287 14.1882Z" fill="black"/>
//                                     </svg>
//                                     <div class="cover" style="width: ${(100 - ((index/5) * 100))}%;"></div>
//                                     ` : `<span>No reviews</span>`
//                                   }
//                                 </label>
//                               </div>
//                             </li>`
//                         )
//                         .join('')}
//                   </ul>
//               </div>
//           </div>
//       </div>
//   </div>
//   `;

//   [...widgetParams.container.querySelectorAll('li.ais-RefinementList-item')].forEach(element => {
//     element.addEventListener('click', function() {
//       const input = element.querySelector('input[type="radio"]');

//       if(input) {
//         refine(input.value);
//       }
//     });
//   });
// };

// // Create the custom widget
// const customNumericMenu = connectNumericMenu(
//   renderNumericMenu
// );

// // Instantiate the custom widget
// instant.search.addWidgets([
//   customNumericMenu({
//     container: document.querySelector('#numeric-menu'),
//     attribute: 'meta.product.okendo_review',
//     items: [
//       { label: '0', start: 0, end: 0.4 },
//       { label: '1', end: 0.5, end: 1.4 },
//       { label: '2', start: 1.5, end: 2.4 },
//       { label: '3', start: 2.5, end: 3.4 },
//       { label: '4', start: 3.5, end: 4.4 },
//       { label: '5', start: 4.5, end: 5 }
//     ],
//   })
// ]);

  // relevant sort
// Create the render function
const renderSortBy = (renderOptions, isFirstRender) => {
  const {
    options,
    currentRefinement,
    refine,
    widgetParams,
    // `canRefine` is only available from v4.45.0
    // Use `hasNoResults` in earlier minor versions.
    canRefine,
  } = renderOptions;

  if (isFirstRender) {
    const select = document.createElement('select');
    select.classList.add("ais-SortBy-select");

    select.addEventListener('change', event => {
      refine(event.target.value);
    });

    widgetParams.container.appendChild(select);
  }

  const select = widgetParams.container.querySelector('select');

  select.disabled = !canRefine;

  select.innerHTML = `
    ${options
      .map(
        option => `
          <option
            value="${option.value}"
            ${option.value === currentRefinement ? 'selected' : ''}
          >
            ${option.label}
          </option>
        `
      )
      .join('')}
  `;
};

// Create the custom widget
const customSortBy = connectSortBy(renderSortBy);

// Instantiate the custom widget
instant.search.addWidgets([
  customSortBy({
    container: document.querySelector('.ais-sort'),
    items: [
      { label: 'Sort By', value: 'glueprodau_products' },
      { label: 'New Arrivals', value: 'New Arrivals' },
      { label: 'Trending', value: 'Trending' },
      { label: 'Price - High to Low', value: 'Price - High to Low' },
      { label: 'Price - Low to High', value: 'Price - Low to High' },
      
     
      
    ],
  })
]);

// Get a reference to the select dropdown element


  // Create a render function
const isRelevantSortedRef = { current: undefined }

const renderRelevantSort = (renderOptions, isFirstRender) => {
  const {
    isVirtualReplica,
    isRelevantSorted,
    refine,
    widgetParams,
  } = renderOptions;
  isRelevantSortedRef.current = isRelevantSorted;

  if (isFirstRender) {
    
    const button = document.createElement('button');

    button.addEventListener('click', () => {
      refine(isRelevantSortedRef.current ? 0 : "Price - High to Low");
    });

    widgetParams.container.appendChild(button);
  }

  const button = widgetParams.container.querySelector('button');
  button.textContent =
    isRelevantSortedRef.current ? 'See all results' : 'See relevant results';
};

// create custom widget
const customRelevantSort = connectRelevantSort(
  renderRelevantSort
);

// instantiate custom widget
// instant.search.addWidgets([
//   customRelevantSort({
//     container: document.querySelector('#relevant-sort'),

//   })
// ]);
  // Mobile facets display
  instant.search.addWidgets([
    {
      init: function() {
        var $button = document.querySelector('.ais-facets-button');
        $button.addEventListener('click', function() {
          var $facets = document.querySelector('.ais-facets');

          if ($facets.classList.contains('ais-facets__shown')) {
            //$button.textContent = 'Refine';
            $facets.classList.remove('ais-facets__shown');
            
          } else {
           // $button.textContent = 'Refine';
            $facets.classList.add('ais-facets__shown');
            $('html').addClass('hide_scroll');
          }
        });
        var $button2 = document.querySelector('.close_filter_algolia');
        $button2.addEventListener('click', function() {
          var $facets = document.querySelector('.ais-facets');

          if ($facets.classList.contains('ais-facets__shown')) {
            //$button.textContent = 'Refine';
            $facets.classList.remove('ais-facets__shown');
            $('html').removeClass('hide_scroll');
          } else {
           // $button.textContent = 'Refine';
            $facets.classList.add('ais-facets__shown');
          }
        });
        var $button3 = document.querySelector('.see-results-button');
        $button3.addEventListener('click', function() {
          var $facets = document.querySelector('.ais-facets');

          if ($facets.classList.contains('ais-facets__shown')) {
            //$button.textContent = 'Refine';
            $facets.classList.remove('ais-facets__shown');
            $('html').removeClass('hide_scroll');
          } else {
           // $button.textContent = 'Refine';
            $facets.classList.add('ais-facets__shown');
          }
        });
        

      },
    },
  ]);
  
  function getPlatform() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
      ? 'mobile'
      : 'desktop'
  }

  instant.search.addWidgets([
    configure({
      analyticsTags: [getPlatform()],
    }),
  ]);

  instant.search.addWidgets([
    configure({
       hitsPerPage: instant.hitsPerPage,
       facetingAfterDistinct: false,
    }),
  ]);
  // Search input
  instant.search.addWidgets([
    searchBox({
      container: '.ais-search-box-container',
     // placeholder: algolia.translations.searchForProduct,
      placeholder: null,
      showReset: false,
      showSubmit: false,
    }),
  ]);
  //adding query to the search title
  instant.search.addWidgets([
    {
      init: function() {
        const searchInput = document.querySelector('#template-search .ais-h2.collection_title_algolia');
        const currentURL = window.location.href;
        const urlSearchParams = new URLSearchParams(currentURL);
        const searchQuery = urlSearchParams.get('q');
        if (searchInput) searchInput.innerHTML = `<div>${algolia.translations.searchTitle}` + ` "${searchQuery}"`+`</div>`; 

    },
  }
  ]);

  // Logo & clear
  instant.search.addWidgets([
    {
      init: function(opts) {
        document
          .querySelector('.ais-clear-input-icon')
          .addEventListener('click', function() {
            opts.helper.setQuery('').search();
            var input = document.querySelector('.ais-search-box--input');
            input.value = '';
            input.focus();
          });
          
      },
      render: function(opts) {
        if (!opts.state.query) {
          document.querySelector('.ais-clear-input-icon').style.display =
            'none';
        } else {
          document.querySelector('.ais-clear-input-icon').style.display = '';
        }
      },
    },
  ]);

  

  // Sort orders
  // if (activeSortOrders.length > 1) {
  //   instant.search.addWidgets([
  //     sortBy({
  //       container: '.ais-sort-orders-container',
  //       items: instant.sortOrders,
  //     }),
  //   ]);
    
  // }

  // Change display
  instant.search.addWidgets([
    {
      init: function() {
        function updateMinHeight() {
          const sourceElement = document.querySelector('.ais-hit--picture');
          const targetElement = document.querySelector('.product-grid__promotion .product-wrap');
    
          if(sourceElement && targetElement){
            var sourceHeight = sourceElement.clientHeight;
            targetElement.style.minHeight = `${sourceHeight}px`;
          } 
        }
        
        
        document
          .querySelector('.ais-search-header .ais-change-display-block')
          .addEventListener('click', function() {
            
            document
              .querySelector(
                '.ais-change-display-block:not(.ais-change-display-selected)'
              )
              .classList.add('ais-change-display-selected');
            document
              .querySelector(
                '.ais-change-display-list.ais-change-display-selected'
              )
              .classList.remove('ais-change-display-selected');
            document
              .querySelector('.ais-results-as-list')
              .classList.replace('ais-results-as-list', 'ais-results-as-block');
              updateMinHeight();
          });
        document
          .querySelector('.ais-search-header .ais-change-display-list')
          .addEventListener('click', function() {
            
            document
              .querySelector(
                '.ais-change-display-list:not(.ais-change-display-selected)'
              )
              .classList.add('ais-change-display-selected');
            document
              .querySelector(
                '.ais-change-display-block.ais-change-display-selected'
              )
              .classList.remove('ais-change-display-selected');
            document
              .querySelector('.ais-results-as-block')
              .classList.replace('ais-results-as-block', 'ais-results-as-list');
              updateMinHeight();
          });
          updateMinHeight();
      },
    },
  ]);

  // Hidden facets
  var list = instant.facets.hidden.map(function(facet) {
    return facet.name;
  });
  instant.search.addWidgets([
    {
      getConfiguration: function() {
        return {
          facets: list,
          disjunctiveFacets: list,
        };
      },
      init: function() {},
    },
  ]);

  // Create the render function
  var createDataAttributes = function(refinement) {
    return Object.keys(refinement)
      .map(function(key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
      })
      .join(' ');
  };

  var renderListItem = function(item) {
    var facet = instant.facets.list.find(function(f) {
      return f.name === item.label;
    });
    return item.refinements
      .map(function(refinement) {
        return (
          '<li class="ais-current-refined-values--item">' +
          '  <a ' +
          createDataAttributes(refinement) +
          '    class="ais-current-refined-values--link">' +
          '    <div>' +
          '      <div class="ais-current-refined-values--label">' +
          facet.title +
          '      </div>: ' +
          refinement.label +
          '    </div>' +
          '  </a>' +
          '</li>'
        );
      })
      .join('');
  };

  var renderCurrentRefinements = function(renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;

    widgetParams.container.innerHTML =
      '<div class="ais-current-refined-values--header ais-facet--header ais-header">Selected filters</div>' +
      '<div class="ais-root ais-current-refined-values ais-facet">' +
      '  <ul class="ais-current-refined-values--list">' +
      items.map(renderListItem).join('') +
      '  </ul>' +
      '</div>';

    Array.prototype.slice
      .call(
        widgetParams.container.querySelectorAll(
          '.ais-current-refined-values--link'
        )
      )
      .forEach(function(element) {
        element.addEventListener('click', function(event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function(
            acc,
            key
          ) {
            var itemData = {};
            itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
            return algolia.assign({}, acc, itemData);
          },
          {});

          refine(item);
        });
      });
  };

  // Create the custom widget
  var customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements
  );

  var hasRefinements = function(helper, facetsList) {
    return facetsList.some(function(f) {
      var isConjunctiveFacetRefined =
        helper.state.isConjunctiveFacet(f.name) &&
        helper.state.isFacetRefined(f.name);
      var isDisjunctiveFacetRefined =
        helper.state.isDisjunctiveFacet(f.name) &&
        helper.state.isDisjunctiveFacetRefined(f.name);
      var isHierarchicalFacetRefined =
        helper.state.isHierarchicalFacet(f.name) &&
        helper.state.isHierarchicalFacetRefined(f.name);

      var numericRefinements = helper.state.getNumericRefinements(f.name);
      var isNumericFacetRefined = Object.keys(numericRefinements).some(function(
        operator
      ) {
        return numericRefinements[operator].length > 0;
      });

      return (
        isNumericFacetRefined ||
        isConjunctiveFacetRefined ||
        isDisjunctiveFacetRefined ||
        isHierarchicalFacetRefined
      );
    });
  };

  /**
   * Decides whether the given `facetName` has any facet values available in
   * the current result set by checking the available `facets`,
   * `disjunctiveFacets` and `hierarchicalFacets`.
   */
  var hasFacetValues = function(resultState, facetName) {
    var isFacetValueAvailable = resultState.facets.some(function(facet) {
      return facet.name === facetName;
    });
    var isDisjunctiveFacetValueAvailable = resultState.disjunctiveFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );
    var isHierarchicalFacetValueAvailable = resultState.hierarchicalFacets.some(
      function(facet) {
        //console.log("is hierarquical: ", resultState.hierarchicalFacets, instant.facets.list)
        return facet.name === facetName;
      }
    );

    return (
      isFacetValueAvailable ||
      isDisjunctiveFacetValueAvailable ||
      isHierarchicalFacetValueAvailable
    );
  };

  var customCurrentRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinements);

  var customCurrentRefinementsCategoriesWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinementsCategories);

  var customCurrentRefinementsStarWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinementsRating);
 

  var clearRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(clearRefinements);

  instant.search.addWidgets([
    clearRefinementsWithPanel({
      container: document.querySelector('.ais-clear-refinements-container'),
      templates: {
        resetLabel: algolia.translations.clearAll,
      },
    }),
    customCurrentRefinementsWithPanel({
      container: document.querySelector(
        '.ais-current-refined-values-container'
      ),
    }),
    customCurrentRefinementsCategoriesWithPanel({
      container: document.querySelector(
        '.ais-current-refined-values-container_categories'
      ),
    })
  ]);

  let scrollTimeOut = null
  function setupBackScroll () {
    if (sessionStorage.getItem('plp-object-id')) {
      let objectId = sessionStorage.getItem('plp-object-id')
      const observer = new MutationObserver((mutations) => {
        if (mutations.find(item => item.target.closest('.ais-product')?.getAttribute(`data-algolia-objectid`) === objectId)) {
          if (scrollTimeOut) {
            clearTimeout(scrollTimeOut)
          }
          scrollTimeOut = setTimeout(() => {
            
            if (document.querySelector(`[data-algolia-objectid="${objectId}"]`)) {
              document.querySelector(`[data-algolia-objectid="${objectId}"]`)
                .closest('.ais-InfiniteHits-item')
                .scrollIntoView({behavior: "smooth", block: "center"});
            }
            observer.disconnect()
          }, 150)
        }
      })

      observer.observe(document.querySelector('.ais-hits-container'), {
        childList: true,
        subtree: true
      })
      sessionStorage.removeItem('plp-object-id')
    }
  }

  /**
   * Setup the facets for search.
   * We are using a `panel` with a custom `hidden` function which will allow
   * us to hide the parent container of the facet if there are no facet values
   * available for that particular facet.
   */
  instant.facets.widgets.forEach(function(widget) {
    var facetWithPanel = panel({
      hidden: function(options) {
        var hide = !hasFacetValues(options.results, widget.params.attribute);
        var displayStyle = hide ? 'none' : '';

        /**
         * Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector
         * can work as expected. "." is supposed to be present for named tags
         * and metafield based facet names and "%" is present when the facet name has a space
         * in it because of the encoding.
         */
        var parentContainerClassName = '.ais-facet-' + encodeURIComponent(
          widget.params.attribute
        ).replace(/\./g, '\\.').replace(/\%/g, '\\%');
        var parentContainer = document.querySelector(parentContainerClassName);

        if (parentContainer) {
          parentContainer.style.display = displayStyle;
        }

        return hide;
      },
    })(widget.widget);

    instant.search.addWidgets([facetWithPanel(widget.params)]);
  });
  let firstCardProcessed = true;
  instant.search.addWidgets([
    
    hits({
      container: '.ais-hits-container',
      cssClasses: {
        root: 'ais-Hits',
        list: [
          'ais-Hits-list'
        ],
        item: 'ais-Hits-item'
      },
      templates: {
        item(hit, {html, components}) {
         
          let queryID = localStorage.getItem("queryID");

          if(queryID != hit.queryID) {
            localStorage.setItem("queryID", hit.queryID);
          }
          
          var slider_recommned = document.querySelector('#shopify-section-recommended-products__collection-page')
          if (slider_recommned) slider_recommned.style.display = "block";
          var collection_description = document.querySelector(".section-collection-rich-text.section");
          if (collection_description) {
            collection_description.style.display = "block";
            if(!isBot) {
              Shopify.theme.jsReadmore && Shopify.theme.jsReadmore.readmore();
            }
          }
          const getConversionData = (e, hit) => {
            const saleDiscount = hit.compare_at_price - hit.price;
            if (!algolia.config.analytics_enabled) return;
            var clickData ={}
            if(algolia.is_collection_results_page){
              
              // clickData = {
              //   index: hit.index,
              //   eventName: 'Added to cart (PLP)',
              //   queryID: hit.queryID,
              //   objectIDs: [hit.objectID],
              // };
              clickData = {
                eventType: "conversion",
                eventSubtype: "addToCart",
                index: hit.index,
                eventName: 'Added to cart (PLP)',
                objectIDs: [hit.objectID],
                objectData: [
                  {
                    queryID: hit.queryID, // optional 
                    price:  hit.price, // required (the sale price is the per item list price minus discount) 
                    discount: saleDiscount > 0 ? Math.round(saleDiscount) : 0,
                    quantity: 1
                  }
                ],
                value: hit.price,
                currency: "AUD" // required
              }; 
            }else{
              // clickData = {
              //   index: hit.index,
              //   eventName: 'Added to cart (Search)',
              //   queryID: hit.queryID,
              //   objectIDs: [hit.objectID],
              // };
              clickData = {
                eventType: "conversion",
                eventSubtype: "addToCart",
                index: hit.index,
                eventName: 'Added to cart (Search)',
                objectIDs: [hit.objectID],
                objectData: [
                  {
                    queryID: hit.queryID, // optional 
                    price:  hit.price, // required (the sale price is the per item list price minus discount) 
                    discount: saleDiscount > 0 ? Math.round(saleDiscount) : 0,
                    quantity: 1
                  }
                ],
                value: hit.price,
                currency: "AUD" // required
              }; 
            }

            /**
             * Uncomment the following function call to start storing data in
             * local storage for conversion tracking
             */
             algolia.saveForConversionTracking(clickData);
          }



          const page = Math.ceil(hit.__position / algolia.config.collections_full_results_hits_per_page );
          let hitHTML  = algolia.instantSearchProductTemplate(firstCardProcessed, page,hit,html, components, getConversionData );
          if (firstCardProcessed) {
           
            firstCardProcessed = false;
          }
  
          return hitHTML;
         
        },
        empty(results, {html}) {
          return algolia.instantSearchNoResultTemplate(html);
        },
        showMoreText: "Load more"
      },
      transformItems: function(items) {

        setupBackScroll()
        
        // Check if promo banner is enabled
        const isPromoBannerEnabled = theme.grid_banner.enable;

        const promoBanner = isPromoBannerEnabled ? {
          objectID: 'promo_banner',
        } : null;
  
        // Add the promo banner as the third hit in the items array
        const itemsWithPromoBanner = isPromoBannerEnabled ? [
          ...items.slice(0, 3),
          promoBanner,
          ...items.slice(3)
        ] : items;
        
        // Remove the last item if the promo banner is present
      const itemsWithoutLastProduct = isPromoBannerEnabled && promoBanner ? itemsWithPromoBanner.slice(0, -1) : itemsWithPromoBanner;
       

        // Filter out items that have the "algolia30days" tag
        const filteredItems = itemsWithoutLastProduct.filter(item => {
          // Check if the item's tags array contains "algolia30days"
          
          if (item.tags){
            return !item.tags.includes('algolia30days');
          }else{
            return true
          }
          
        });
        // Define the node to which you want to append the schema
        let targetNode = document.querySelector('#template-collection');

        if(targetNode) {
          let schema = {
            "@context": "https://schema.org",
            "@type": "OfferCatalog",
            "itemListElement": filteredItems.map((item, index) => ({
              "@type": "ListItem",
              "position": index + 1,
              "url": window.location.origin + '/products/' + item.handle,
              "name": item.title
            }))
          };

          // Check if a script tag already exists
          let script = targetNode.querySelector('script[type="application/ld+json"]');

          if (script) {
            // If a script tag exists, replace its content
            script.text = JSON.stringify(schema);
          } else {
            // If no script tag exists, create a new one and append it to the target node
            script = document.createElement('script');
            script.type = 'application/ld+json';
            script.text = JSON.stringify(schema);
            targetNode.appendChild(script);
          }
        }

        // Create the JSON-LD schema
        

        return filteredItems.map(item => ({
          ...item,
          _distinct: instant.distinct,
          can_order:
            item.inventory_management !== 'shopify' ||
            item.inventory_policy === 'continue' ||
            item.inventory_quantity > 0,
          queryID: item.__queryID,
          index: instant.search.mainIndex.getIndexName(),
          distinct: true
        }));
      }
    })
  ]);

  // Stats
  instant.search.addWidgets([
    stats({
      container: '.ais-stats-container',
      templates: {
        text(data, {html}){
          return algolia.instantSearchStatsTemplate(data, html)
        }
      }
    }),
  ]);
  

  // Redirect to product on click
  instant.search.addWidgets([
    {
      init: function() {
        var container = document.querySelector('.ais-hits-container');
       
        container.addEventListener('click', function(e) {
          var el = e.target;
          var hit;
          do {
            if (el.matches('.ais-hit')) {
              hit = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!hit) {
            return;
          }
          var $this = hit;
         
          var productHandle = $this.dataset.handle;
          var variant_id = $this.dataset.variantId;
          var distinct = $this.dataset.distinct;
          //console.log("$this: ",hit)

          // Construct the link we should redirect to
          var link = '';

          // If we're on a collection page and the handle is available
          // then prefix the product link with the collection handle
          if (collectionPageEnabled && collectionHandle) {
            link = '/collections/' + collectionHandle;
          }

          // Add the product handle to the link
          link = link + '/products/' + productHandle;

          // Add the variant ID details to redirect to a specific
          // variant ID if we are showing variants and not products
          if (distinct !== 'true') {
            link += '?variant=' + variant_id;
          }
          
          if (algolia.config.analytics_enabled) {
            
            var clickData = {}
            var clickData_pdp ={}
            const saleDiscount = parseInt(hit.dataset.comparePrice) - parseInt(hit.dataset.price);

            if(algolia.is_collection_results_page){
               clickData = {
                eventType: "view",
                index: hit.dataset.algoliaIndex,
                eventName: 'View Collection',
                queryID: hit.dataset.algoliaQueryid,
                objectIDs: [hit.dataset.algoliaObjectid],
              };
              // clickData_pdp = {
              //   index: hit.dataset.algoliaIndex,
              //   eventName: 'added to cart (PDP - Collection)',
              //   queryID: hit.dataset.algoliaQueryid,
              //   objectIDs: [hit.dataset.algoliaObjectid],
              // }; 
              clickData_pdp = {
                eventType: "conversion",
                eventSubtype: "addToCart",
                index: hit.dataset.algoliaIndex,
                eventName: 'Added to cart (PDP - collection)',
                objectIDs: [hit.dataset.algoliaObjectid],
                objectData: [
                  {
                    // revenue data for 'black-t-shirt-xxl'
                    queryID: hit.dataset.algoliaQueryid, // optional 
                    price: parseInt(hit.dataset.price), // required (the sale price is the per item list price minus discount) 
                    quantity: 1,
                    discount: saleDiscount > 0 ? Math.round(saleDiscount) : 0
                  }
                ],
                value: parseInt(hit.dataset.price),
                currency: "AUD" // required
              }; 
            }else{
               clickData = {
                eventType: "view",
                index: hit.dataset.algoliaIndex,
                eventName: 'View Search',
                queryID: hit.dataset.algoliaQueryid,
                objectIDs: [hit.dataset.algoliaObjectid],
              };
              clickData_pdp = {
                eventType: "conversion",
                eventSubtype: "addToCart",
                index: hit.dataset.algoliaIndex,
                eventName: 'Added to cart (PDP - search)',
                objectIDs: [hit.dataset.algoliaObjectid],
                objectData: [
                  {
                    // revenue data for 'black-t-shirt-xxl'
                    queryID: hit.dataset.algoliaQueryid, // optional 
                    price:  hit.dataset.price, // required (the sale price is the per item list price minus discount) 
                    quantity: 1,
                    discount: saleDiscount > 0 ? Math.round(saleDiscount) : 0
                  }
                ],
                value: hit.dataset.price,
                currency: "AUD" // required
              }; 
              

            }
          
            
            //aa.clickedObjectIDsAfterSearch(clickData);
            /**
             * Uncomment the following function call to start storing data in
             * local storage for conversion tracking
             */
             algolia.saveForConversionTracking(clickData);
             //const data_algolia = JSON.parse(clickData);
             const localStorageKey_pdp = 'localStorageKey_pdp';
             localStorage.setItem(localStorageKey_pdp, JSON.stringify(clickData_pdp))
             
          }
         // window.location.href = link;
        });
      },
    },
  ]);

  // Add to cart
  instant.search.addWidgets([
    {
      init: function() {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var cartButton;
          do {
            if (el.matches('.ais-hit--cart-button')) {
              cartButton = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!cartButton) {
            return;
          }

          e.stopPropagation();
          var $this = cartButton;
          var formId = $this.dataset.formId;

          if (formId) {
            document.getElementById(formId).submit();
          }
        });
      },
    },
  ]);

  // No result actions
  instant.search.addWidgets([
    {
      init: function(opts) {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearFilters;
          do {
            if (el.matches('.ais-hit-empty--clear-filters')) {
              clearFilters = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearFilters) {
            return;
          }

          var helper = opts.helper;
          helper.clearTags();
          instant.facets.list.forEach(function(facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });

        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearInput;
          do {
            if (el.matches('.ais-hit-empty--clear-input')) {
              clearInput = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearInput) {
            return;
          }

          opts.helper.setQuery('').search();
          var input = document.querySelector('.ais-search-box--input');
          input.value = '';
          input.focus();
        });
      },
    },
  ]);

  // Pagination
    instant.search.addWidgets([
      pagination({
        container: '.ais-pagination-container',
        padding: 2,
        maxPages: 20,
        scrollTo: false
      }),
    ]);

  function updateMinHeight() {
    const sourceElement = document.querySelector('.ais-hit--picture');
    const targetElements = document.querySelectorAll('.product-grid__promotion .product-wrap');

    if(sourceElement && targetElements){
      var sourceHeight = sourceElement.clientHeight;
     
        targetElements.forEach(function(targetElement) {
        targetElement.style.minHeight = `${sourceHeight}px`;
      });
     } 
  }

if(!isBot) {
  let lastRenderArgs;
  let isLoading = false;

  const loader = document.createElement('div');
  loader.className = 'loader plp-loader';
  loader.style.display = 'none';

  function buildProductCounter (totalProducts, viewedProducts, container) {
    
    const barWidth = (viewedProducts / totalProducts) * 100

    const template = `
      <div id="product-counter" class="product-counter"> 
        <span> You have viewed ${viewedProducts} of ${totalProducts} styles </span>
        <div id="counter-progress-bar"> <span style="width: ${barWidth}%;"></span> </div>
      </div>
    `
    container && container.insertAdjacentHTML("afterend", template)
  }

  function destroyProductCounter (container) {
    const productsCounter = container.querySelectorAll("#product-counter")

    productsCounter.forEach(item => {
      item.remove()
    })
    
  }

  let lastPage = 0

  //Infinite scroll
  const infiniteHits = connectInfiniteHits(
    (renderArgs, isFirstRender) => {
      //console.log("renderArgs", renderArgs);
      const { hits, showMore, widgetParams, isFirstPage, showPrevious , currentPageHits} = renderArgs;
      const { container } = widgetParams;
      const containerHits = container.querySelector('ol')
      const root = container.querySelector('.ais-InfiniteHits')
      lastRenderArgs = renderArgs;
      //console.log("currentPageHits", currentPageHits)
      //console.log("hits", hits);
      const totalProducts = renderArgs.results?.nbHits
      let viewedProducts = renderArgs.hits.length
      
      function historyLastPage(hit) {
        const productCard = document.querySelector(`.product_algolia_${hit.id}`)
        if (productCard){
          productCard.addEventListener("click", (event)=> {
            if(!event.target.classList.contains('flickity-button') && event.target.closest('.flickity-button') === null) {
              sessionStorage.setItem('plp-object-id', productCard.getAttribute('data-algolia-objectid'))
              const page = productCard.getAttribute('data-page')
              const url = new URL(location);
              url.searchParams.set("page", page);
              url.searchParams.set("scrollTo", productCard.getAttribute('data-url'));
    
              history.pushState({}, 'anchor-product', url);
            }
          })
        }
      }

      hits.map(hit => historyLastPage(hit));

      if (!isFirstPage) {
        const url = new URL(window.location.href)
        const page = renderArgs?.results?.page ? renderArgs.results.page + 1 : url.searchParams.get("page");
        if(page >= lastPage) {
          lastPage = page
        }
        viewedProducts = lastPage * 20;
        if(renderArgs.results) {
          viewedProducts = Math.min(viewedProducts, renderArgs.results.nbHits)
        }
      }


      destroyProductCounter(container)
     
      buildProductCounter(totalProducts, viewedProducts, containerHits)
      
      if(isFirstRender) {
        container.insertAdjacentElement("afterend", loader)
        
        setTimeout(() => {
          if (container.querySelector(".ais-InfiniteHits-loadMore")){
            const loadMoreButton = container.querySelector(".ais-InfiniteHits-loadMore")
            loadMoreButton.addEventListener("click", ()=> {
            /* showMore() */
            loader.style.display = 'block';
            updateMinHeight();
            isLoading = true;
          })
          }
          
        }, 300);


        if(!isFirstPage) {
          const button = `<div class="ais-InfiniteHits-loadPrev"> Show Previous</div>`
          container.insertAdjacentHTML("beforebegin", button)
          document.querySelector('.ais-InfiniteHits-loadPrev').addEventListener("click", showPrevious)
        }
        return
      }

      if (!isFirstRender) {
        setTimeout(() => {
          var page = (new URLSearchParams(window.location.search)).get("page")
          if (!page || page == "1") {
            $(".collection-banner-wrap").removeClass("hidden")
          } else {
            $(".collection-banner-wrap").addClass("hidden")
          }
        }, 2000)
      }

      if (isLoading) {
        
        setTimeout(() => {
          loader.style.display = 'none';
          isLoading = false;
        }, 3000);
      }

    }
  )

    instant.search.addWidgets([
    infiniteHits({
      container: document.querySelector('.ais-hits-container'),
      cssClasses: {
        root: 'ais-Hits',
        list: [
          'ais-Hits-list'
        ],
        item: 'ais-Hits-item'
      },
      showPrevious: true,
      // transformItems: function (items) {
      //   return items.map((item, index) => ({
      //     ...item,
      //     _distinct: instant.distinct,
      //     can_order:
      //       item.inventory_management !== 'shopify' ||
      //       item.inventory_policy === 'continue' ||
      //       item.inventory_quantity > 0,
      //     queryID: item.__queryID,
      //     productPosition: item.__position,
      //     index: instant.search.mainIndex.getIndexName(),
      //     item_index: "TEST NAT"
      //   }));
      // }
    })
  ]);
}
  


  
    var sourceDiv = document.querySelector('.collection__top');
    if (sourceDiv) {
        var clonedDiv = sourceDiv.cloneNode(true); 
        
        var h2Elements = clonedDiv.querySelectorAll('h2');
        h2Elements.forEach(function(element) {
            var newH1Element = document.createElement('h1');
            newH1Element.innerHTML = element.innerHTML;
            //newH1Element.classList.add('collection_title_algolia'); // Add the class
            element.parentNode.replaceChild(element, element);
        });

        //var targetDiv = document.querySelector('.algolia_breadcrumbs');
        sourceDiv.appendChild(clonedDiv);
    }
    
  
    
  instant.search.start();
  // after all elements have been loaded
  instant.search.on('render', () => {
    document.querySelectorAll('.ais-Pagination-link').forEach((el) => {
      el.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          window.location.href = el.getAttribute('href');
      })
    })
    function isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    }
    

    const productCards = document.querySelectorAll('.image-element__wrap.second_image_algolia.load_slider');
   
    // Iterate over each product card element
    if(productCards){
      productCards.forEach(parentElement_image => {
        // Initialize Flickity slider if the element exists
        if (parentElement_image) {
            $(parentElement_image).flickity({
                pageDots: false,
                draggable: true,
                lazyLoad: 1
            }); 
        }
        
      });
    }
    
    var targetImages = document.querySelectorAll('.first-card-true img.fade-in-from-left.swap--visible.secondary');
    // console.log(targetImages)
    // Apply initial transition style
    targetImages.forEach(function(image) {
        image.style.transition = "transform 1s ease-in-out";
    });

    // Function to apply the transform
    function applyTransform() {
        targetImages.forEach(function(image) {
            image.style.transform = "translateX(-66%)";
        });
    }

    // Function to remove the styles after the transition
    function removeStyles() {
        targetImages.forEach(function(image) {
            // image.style.transition = "";
            image.style.transform = "";
        });
    }
    if (isMobile()){
      // Apply the transform after 2 seconds
      setTimeout(applyTransform, 2000);
      // Remove the styles after the transition is complete
      setTimeout(removeStyles,3500); //3000ms delay + 500ms transition time

    }
    


    updateMinHeight();
   
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    if(window._swat){
      
      window._swat.initializeActionButtons(".ais-hits-container");
    }else{
      
      window.SwymCallbacks = window.SwymCallbacks || [];
  
      window.SwymCallbacks.push(function(){
        window._swat.initializeActionButtons(".ais-hits-container");
      });
    }
    const searchInput = document.querySelector('#template-search .ais-h2.collection_title_algolia');
    
    function isParameterInURL(parameterName) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      return urlParams.get(parameterName);
    }
    
    if (searchInput) searchInput.innerHTML = `<div>${algolia.translations.searchTitle + " "  +`"`+ isParameterInURL('q')}"</div>`;

    var selectElement = document.querySelector(".ais-SortBy-select"); 
    if (selectElement){
      var placeholderOption = selectElement.querySelector(`option[value="${algoliaShopify.config.index_prefix}products"]`);
      
    
      if (placeholderOption) {
        // Placeholder option already exists, update its value and text
        placeholderOption.value = `${algoliaShopify.config.index_prefix}products`;
        placeholderOption.text = "Sort By";
      } else {
        // Placeholder option doesn't exist, create a new one
        var newOption = document.createElement("option");
        newOption.value = `${algoliaShopify.config.index_prefix}products`;
        newOption.text = "Sort By";
        // Insert the new option as the first option
        selectElement.insertBefore(newOption, selectElement.firstChild);
      }
    }
    // Set the placeholder text
    const searchBar = document.getElementById("autocomplete-0-input");
    if (searchBar) {
      if(searchBar  && !searchBar.hasAttribute("aria-controls") ){
        searchBar.placeholder = null;
      }
      const initialPlaceholder = searchBar.placeholder;
      searchBar.addEventListener("input", function() {
        // If the input field is empty, restore the initial placeholder text
        if (!searchBar.hasAttribute("aria-controls")) {
          searchBar.placeholder = initialPlaceholder;
        } else {
          // If the input field has text, clear the placeholder
          searchBar.placeholder = "test";
        }
      });
    }
    

    // Get the <ul> element by its ID
    const myList = document.querySelector('.ais-current-refined-values--list');
    if(myList){
      // Get all <li> elements inside the <ul>
      const liItems = myList.querySelectorAll('li');
      // Get the number of <li> items
      const numberOfItems = liItems.length;
      if(numberOfItems > 0) {

         const quantityDiv = document.getElementById('filter_quantity');
         quantityDiv.innerText = `(${numberOfItems})`;

        
        
      // console.log(`The <ul> element contains ${numberOfItems} <li> items.`);
      }else{
        const quantityDiv = document.getElementById('filter_quantity');
        quantityDiv.innerText = ``;

      }
    }
    // JavaScript code for the sort by width 
    const sortBySelect = document.querySelector(".ais-SortBy-select");
    function adjustSelectWidth() {
     //console.log("sortBySelect" , sortBySelect)
      if (sortBySelect){

     
        const selectedOption = sortBySelect.options[sortBySelect.selectedIndex];
        const selectedOptionText = selectedOption.textContent;

        // Create a temporary element to measure the width of the option text
        const tempElement = document.createElement('span');
        tempElement.style.visibility = 'hidden';
        tempElement.style.position = 'absolute';
        tempElement.textContent = selectedOptionText;
        document.body.appendChild(tempElement);

        // Set the width of the select to match the width of the option text
        sortBySelect.style.width = `${tempElement.clientWidth + 28}px`; // Add some padding

        // Remove the temporary element
        document.body.removeChild(tempElement);
      }
    }

    // Add event listener to adjust the width when the selection changes
    if(sortBySelect){
      sortBySelect.addEventListener('change', adjustSelectWidth);
    }
   

    // Set the initial width when the page loads
    adjustSelectWidth();

    const fixedDiv = document.querySelector('.ais-search-header');
    const targetDiv = document.querySelector('.mobile-header');
    const filters_parent_mobile = document.querySelector('.algolia_breadcrumbs');
    
    var targetDivHeight = 0;
    var isSticky = false;
    var prevScrollY = 0;
    
    if (targetDiv) {
      targetDivHeight = targetDiv.offsetHeight;
    }
    
    function isFullyVisible(element) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      );
    }
    
    function updateFixedState() {
      const filtersMobileRect = filters_parent_mobile?.getBoundingClientRect();
      const currentScrollY = window.scrollY || window.pageYOffset;
      if (currentScrollY > prevScrollY) {
        // Scrolling down
        if (filtersMobileRect?.top <= targetDivHeight && !isSticky) {
          
          // If the filters_mobile div is below the targetDiv and not already sticky, make it sticky below the targetDiv
          fixedDiv.classList.add('sticky-enabled');
          fixedDiv.style.top = '0';
          isSticky = true;
        } else if (filtersMobileRect?.top > targetDivHeight && isSticky) {
          
          // If the filters_mobile div is above the targetDiv and the div is sticky, remove sticky behavior
          fixedDiv.classList.remove('sticky-enabled');
          fixedDiv.style.top = '';
          isSticky = false;
        }else if (filtersMobileRect?.top <= targetDivHeight && isSticky) {
          fixedDiv.style.top = '0';
        }

      } else {
          if (currentScrollY === 0 && isSticky) {
            
            // If at the top of the page and the div is sticky, make it sticky at the top
            fixedDiv.classList.remove('sticky-enabled');
            fixedDiv.style.top = '0';
          } else if (filtersMobileRect?.top <= targetDivHeight && isSticky) {
            
            // If the filters_mobile div is below or at the level of the targetDiv and the div is not sticky, make it sticky below the targetDiv
            const mobileHeader = document.getElementById('mobile-header');
            fixedDiv.classList.add('sticky-enabled');
            if(!mobileHeader.classList.contains('sticky--enabled')){
              fixedDiv.style.top = '0';
            }else {
              fixedDiv.style.top = targetDivHeight - 2 + 'px';
            }
            isSticky = true;
          } 
          // else if (isSticky && filtersMobileRect?.top > targetDivHeight) {
          
          //   // If the filters_mobile div is above the targetDiv and the div is sticky, remove sticky behavior
          //   fixedDiv.classList.remove('sticky-enabled');
          //   fixedDiv.style.top = '';
          //   isSticky = false;
          // }
      }
    
      // Update the previous scroll position
      prevScrollY = currentScrollY;
    }
    
    // Listen for the scroll event and update the fixed state
    window.addEventListener('scroll', updateFixedState);
    
    // Initial update to set the fixed state on page load (in case the div is already off the viewport)
    /* updateFixedState(); */

    const ulElement = document.querySelector('#hierarchical-menu .ais-RefinementList-list');
    var hide_categories= document.querySelector(".ais-facet-dropdown-wrapper.ais-facet-categories.ais-facet-categories");
    // Check if it's empty
    if (ulElement.childElementCount === 0) {
      // Hide the <ul> element
      ulElement.style.display = 'none';
      hide_categories.style.display ="none";
    }else{
      ulElement.style.display = 'block';
      hide_categories.style.display ="block";
    }

    const ulElement_selected_categ = document.querySelector('.categories_selected ul.ais-current-refined-values--list');
    var hide_categories_refinement= document.querySelector(".ais-current-refined-values-container_categories");
    // Check if it's empty
    
    if(ulElement_selected_categ){
      if (ulElement_selected_categ.childElementCount === 0) {
        // Hide the <ul> element
        hide_categories_refinement.classList.add('hidden');
       
      }else{
        hide_categories_refinement.classList.remove('hidden');
       
      }
    }
    var overlay = document.querySelector('#overlay_algolia');
    var filter_container = document.querySelector(".ais-facets.test")
    var dom_html = document.querySelector('html')
    overlay.addEventListener('click', () => {
      filter_container.classList.remove('ais-facets__shown');
      dom_html.classList.remove('hide_scroll')
    });

  });


  algolia.contentHide.parentNode.removeChild(algolia.contentHide);

  instant.search.addWidgets([
    queryRuleContext({
       trackedFilters: {
        ['options.size']: values => values,
       },
       transformRuleContexts(ruleContexts) {
          const ruleContextSet = new Set(ruleContexts)
          
          // Only add SizeFilterActive if any rule context contains "options_size"
          const hasSizeFilter = ruleContexts.some(context => context.includes('options_size'));
          if (hasSizeFilter) {
            return ['SizeFilterActive']
          }
          
          return [...ruleContextSet];
       }
    })
  ]);

})(window.algoliaShopify);

